import PortfolioIcon from 'icons/Portfolio.icon';
import BriefcaseIcon from 'icons/Briefcase.icon';
import OfficebuildingIcon from 'icons/Officebuilding.icon';
import BoltIcon from 'icons/Bolt.icon';
import {
  BUSINESS_ROUTE,
  BUYING_LABEL,
  BUYING_PORTFOLIO_ROUTE,
  SELLER_LABEL,
  SELLING_PORTFOLIO_ROUTE,
  URGENT_ROUTE,
} from 'data/global';

export const toLandingLinks = [
  {
    label: 'buy',
    href: '/buyer',
  },
  {
    label: 'sell',
    href: '/seller',
  },
  {
    label: 'broker',
    href: '/broker',
  },
] as const;

export const newsLink = {
  label: 'news',
  href: '/news',
};

export const businessLink = {
  href: BUSINESS_ROUTE,
  label: 'goingConcernListings',
  icon: OfficebuildingIcon,
};

export const urgentLink = {
  href: URGENT_ROUTE,
  label: 'urgentListings',
  icon: BoltIcon,
};

export const buyingLink = {
  label: BUYING_LABEL,
  href: BUYING_PORTFOLIO_ROUTE,
  icon: PortfolioIcon,
};

export const sellingLink = {
  label: SELLER_LABEL,
  href: SELLING_PORTFOLIO_ROUTE,
  icon: BriefcaseIcon,
};

export const bossModeDealsLinks = [sellingLink];

export const dealsLinks = [buyingLink, sellingLink];

export const headerListingLinks = [businessLink, urgentLink];

export const solutionsLinks = [...toLandingLinks, newsLink];
